/**
 * <StatsTile> Component
 */
import PropTypes from 'prop-types';
/** @jsx jsx this comment is required for Storybook to render */
import { css, jsx } from '@emotion/core';
import {
  fontFamilies,
  fontSizes,
  lineHeights,
  unitConverter as uc,
} from '../../../styles/base';
import StatsTileCard from '../StatsTileCard/StatsTileCard';
import TileContainer from '../TileContainer/TileContainer';

const StatsTile = props => {
  const { statsTileCards } = props;

  const statsTileSize = Object.keys(statsTileCards).length;

  const twoStatsTilesCss = css`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 100%;
    height: ${uc('475px')};

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: ${uc('220px')};
      margin: 0 auto;
    }

    div h3 {
      max-width: ${uc('325px')};
      margin-bottom: ${uc('10px')};
      font-size: ${fontSizes.fifty};
      font-family: ${fontFamilies.proximaSoft};
      line-height: initial;
      text-align: center;
    }

    div p {
      margin: 0 auto;
      padding: ${uc('0 30px')};
      font-size: ${fontSizes.twentyTwo};
      font-family: ${fontFamilies.proximaSoft};
      line-height: ${lineHeights.copy};
      text-align: center;
    }

    div a {
      margin-top: ${uc('15px')};
    }
  `;

  const threeStatsTilesCss = css`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 100%;
    height: ${uc('500px')};
    font-family: ${fontFamilies.proximaSoft};

    div {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      height: ${uc('150px')};
    }

    div h3 {
      max-width: ${uc('150px')};
      margin: ${uc('0 15px 0 30px')};
      font-size: ${fontSizes.fifty};
      font-family: ${fontFamilies.proximaSoft};
      white-space: nowrap;
    }

    div p {
      max-width: ${uc('250px')};
      margin: ${uc('0 30px 0 auto')};
      font-size: ${fontSizes.twentyFive};
      font-family: ${fontFamilies.proximaSoft};
      line-height: 1.25;
      text-align: center;
    }
  `;

  const tileContainerCss = css`
    margin-bottom: ${uc('50px')};
  `;

  const renderedStatsTileCards = statsTileCards.map(statsTileCard => (
    <StatsTileCard
      key={`statsTileCard-component-${statsTileCard._key}`}
      {...statsTileCard}
    />
  ));

  return (
    <TileContainer css={tileContainerCss}>
      <div css={statsTileSize === 2 ? twoStatsTilesCss : threeStatsTilesCss}>
        {renderedStatsTileCards}
      </div>
    </TileContainer>
  );
};

StatsTile.propTypes = {
  statsTileCards: PropTypes.arrayOf(PropTypes.shape({})),
};

StatsTile.defaultProps = {
  statsTileCards: [],
};

export default StatsTile;
